import { Pinia, Store } from 'pinia-class-component';
import { initClient } from '../../api';
import { KindType, TestEquipmentKindTypeAPIControllerUIClient } from '../../components/backend/backendapi';

@Store({
  id: 'KindTypeStore',
  name: 'KindTypeStore',
})
export default class KindTypeStore extends Pinia {
  private readonly api = initClient(TestEquipmentKindTypeAPIControllerUIClient);

  //data
  private _loadingPromise: Promise<KindType[]> | null = null;
  private _kindTypes: KindType[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get kindTypes(): KindType[] {
    return this._kindTypes;
  }

  get kindTypesById(): Map<number, KindType> {
    return new Map(this._kindTypes.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._kindTypes.splice(0);
  }

  setKindTypes(kindTypes: KindType[]): void {
    this._kindTypes.splice(0);
    this._kindTypes.push(...kindTypes);
  }

  rememberKindType(kindType: KindType): void {
    const index = this._kindTypes.findIndex(e => e.id === kindType.id);
    if (index >= 0) {
      this._kindTypes.splice(index, 1, kindType);
    } else {
      this._kindTypes.push(kindType);
    }
  }

  forgetKindType(kindType: KindType): void {
    const index = this._kindTypes.findIndex(e => e.id === kindType.id);
    if (index >= 0) {
      this._kindTypes.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list();
      const kindTypes = await this._loadingPromise;
      this.setKindTypes(kindTypes ?? []);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._kindTypes.length > 0) {
      return;
    }
    return await this.reload();
  }
}